import { Icon, Switch } from '@atom/mui';
import { AccountCircleIcon } from '@atom/mui/icons';

import { useMapLayers } from '../MapPortalDataProvider';

import classes from './filterPanel.module.css';

const UsersSection = () => {
  const { layers, setLayer } = useMapLayers();
  const { users: toggled } = layers;

  return (
    <div className={classes.sectionContainer}>
      <div className={classes.sectionHeaderContainer}>
        <Switch
          label={
            <div className={classes.toggleLabel}>
              <div className={classes.sectionHeaderIcon}>
                <Icon icon={AccountCircleIcon} />
              </div>
              <div>Team</div>
            </div>
          }
          checked={toggled}
          onChange={() => setLayer('users', !toggled)}
          data-cy="dashboardTeamToggle"
        />
      </div>
    </div>
  );
};

export default UsersSection;
